import React from "react";

const StatGroup = ({ stats = [] }) => {
  if (!stats.length) {
    return null;
  }

  return (
    <div className="stat-group" role="list">
      {stats.map((stat, index) => (
        <div className="stat-group__item" key={index} role="listitem">
          {stat.value && (
            <strong className="stat-group__value">{stat.value}</strong>
          )}
          {stat.label && (
            <span className="stat-group__label">{stat.label}</span>
          )}
          {stat.description && (
            <span className="stat-group__description">{stat.description}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default StatGroup;
